/**
 * [key]:                          value
 * [GTM attributes.businessName]: LP line f business
 */
const brandMapping = {
    mrp: 'mrporter',
    nap: 'net-a-porter',
    theoutnet: 'TON',
};

/**
 * Returns an Array containing info about the page.
 * Filters falsy values and makes sure there are no duplicate entrties
 * @param {Object} page
 * @param {Object} page.attributes
 * @param {Object} page.pageInfo
 * @param {Object} page.category
 * @param {Array<string>} page.additionalSections
 */
export const formatSectionData = ({ attributes, pageInfo, category, additionalSections = [] } = {}, customSection) => {
    const sections = Array.from(
        new Set([
            pageInfo?.language,
            brandMapping[attributes?.businessName?.toLowerCase()] || attributes?.businessName,
            pageInfo?.pageName,
            category?.pageType,
            category?.subCategory1,
            category?.subCategory2,
            category?.subCategory3,
            category?.subCategory4,
            ...additionalSections,
        ]),
    ).filter(Boolean);
    return customSection ? sections.map((item) => `${item} ${customSection}`) : sections;
};

/**
 * Maps data structure from GTM to LP
 * @param {Array} products
 * @param {string} productIdentifier prop of products.productInfo to map to returned product.sku
 * @returns {Array}
 */
export const formatProductData = (products = [], productIdentifier = 'sku') =>
    products?.map(
        ({
            productInfo: { productName, name, manufacturer, ...productInfo },
            category: { primaryCategory },
            price: { priceWithDiscountTax, basePrice },
            quantity,
        }) => ({
            product: {
                name: `${manufacturer} : ${productName || name}`,
                category: primaryCategory,
                sku: productInfo[productIdentifier],
                price: priceWithDiscountTax || basePrice,
            },
            quantity,
        }),
    );

/**
 * Promise resolves true when condition is met during looping with a given timer and max retry
 * @param condition
 * @param retry
 * @param timer
 * @returns {Promise<unknown>}
 */
export const waitUntil = (condition, retry, timer) => {
    let times = 0;
    return new Promise((resolve) => {
        const interval = setInterval(() => {
            times++;
            if (condition()) {
                resolve(true);
                clearInterval(interval);
            } else {
                if (times >= retry) {
                    resolve(false);
                    clearInterval(interval);
                }
            }
        }, timer);
    });
};
